import { isPracticeEntry, practiceFee } from "@common/localPractice";
import { getPracticeEntry, setPracticeEntry } from "./practiceEntry";
import { initAffiliate } from "./affiliate";
import { initFieldManual } from "./fieldManual";
import { initAccounts } from "./accounts";

/** Lobby presentation and server-owned fictional referral credits. */
export function initMomoMenu(): void {
    initAccounts();
    const help = document.querySelector<HTMLDialogElement>("#momo-help-dialog");
    const wallet = document.querySelector<HTMLDialogElement>("#momo-wallet-dialog");
    if (!help || !wallet) throw new Error("MOMO menu dialogs are missing");
    initFieldManual(help);
    document.querySelectorAll<HTMLButtonElement>("[data-momo-help]").forEach(button => {
        button.addEventListener("click", () => help.showModal());
    });
    document.querySelectorAll<HTMLButtonElement>("[data-momo-close]").forEach(button => {
        button.addEventListener("click", () => button.closest("dialog")?.close());
    });
    const entryButtons = document.querySelectorAll<HTMLButtonElement>("[data-momo-entry]");
    const refreshEntry = (): void => {
        const selected = getPracticeEntry();
        entryButtons.forEach(button => button.setAttribute("aria-pressed", String(Number(button.dataset.momoEntry) === selected)));
        const net = document.querySelector("#momo-net-entry");
        if (net) net.textContent = `$${((selected - practiceFee(selected)) / 100).toFixed(2)}`;
    };
    entryButtons.forEach(button => button.addEventListener("click", () => {
        const entry = Number(button.dataset.momoEntry);
        if (isPracticeEntry(entry)) setPracticeEntry(entry);
    }));
    document.addEventListener("practice-entry-change", refreshEntry);
    refreshEntry();
    const methods = wallet.querySelectorAll<HTMLButtonElement>("[data-momo-method]");
    const selectMethod = (method: string): void => {
        methods.forEach(button => button.setAttribute("aria-pressed", String(button.dataset.momoMethod === method)));
        const caption = wallet.querySelector("#momo-payment-method-note");
        if (caption) caption.textContent = method === "crypto" ? "Crypto · USDT, SOL, ETH" : "Binance Pay";
    };
    methods.forEach(button => button.addEventListener("click", () => selectMethod(button.dataset.momoMethod ?? "binance")));
    document.querySelectorAll<HTMLButtonElement>("[data-momo-wallet]").forEach(button => button.addEventListener("click", () => {
        selectMethod(button.dataset.momoWallet || "binance");
        wallet.showModal();
    }));
    const amounts = wallet.querySelectorAll<HTMLButtonElement>("[data-momo-amount]");
    amounts.forEach(button => button.addEventListener("click", () => {
        amounts.forEach(option => option.setAttribute("aria-pressed", String(option === button)));
        const summary = wallet.querySelector("#momo-topup-total");
        if (summary) summary.textContent = `$${Number(button.dataset.momoAmount).toFixed(2)}`;
    }));
    for (const [attribute, id] of [["data-momo-cashout", "momo-cashout-dialog"], ["data-momo-affiliate", "momo-affiliate-dialog"]]) {
        document.querySelectorAll<HTMLButtonElement>(`[${attribute}]`).forEach(button => button.addEventListener("click", () => {
            document.querySelector<HTMLDialogElement>(`#${id}`)?.showModal();
        }));
    }
    initAffiliate();
}
